import axios from "axios";
export const getCoupons = async (currentPage) => {
  try {
    const response = await axios.get(
      `${
        process.env.REACT_APP_BASEURL
      }/api/user/couponcode?page=${currentPage}&size=${100}`,
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return response;
  } catch (err) {
    return null;
  }
};
